import httpClient from "./httpConfig";

//END POINTS
const SALESFORCE_ENDPOINT = "/api/sitecore/ProForm/SubmitDataToSalesforce";

const sendDataToSalesForce = options => {
  return httpClient.post(SALESFORCE_ENDPOINT, options);
};

export { sendDataToSalesForce };
